import type { RestaurantFormData } from "../../restaurant.types";

interface BasicInfoProps {
  formData: RestaurantFormData;
  updateFormData: (updatedFields: Partial<RestaurantFormData>) => void;
}


const BasicInfo: React.FC<BasicInfoProps> = ({ formData, updateFormData }) => {
  return (
  <div className="space-y-6">
    {/* BASIC INFO */}
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-3">Basic Information</h3>
      <div className="space-y-3">

        {/* NAME */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Restaurant Name *
          </label>
          <input
            type="text"
            value={formData?.name}
            onChange={(e) => updateFormData({ name: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
            placeholder="Enter restaurant name"
          />
        </div>

        {/* DESCRIPTION */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description *
          </label>
          <textarea
            value={formData?.description}
            onChange={(e) => updateFormData({ description: e.target.value })}
            rows={4}
            className="w-full min-h-60 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
            placeholder="Describe your restaurant"
            maxLength={700}
          />
          <p className="text-sm text-gray-500 mt-1">
            {formData.description.length}/700 characters
          </p>
        </div>
      </div>
    </div>

    {/* CONTACT INFO */}
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Information</h3>

      <div className="space-y-3">

        {/* PHONE */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone
          </label>
          <input
            type="text"
            value={formData?.contactInfo?.phone}
            onChange={(e) =>
              updateFormData({
                contactInfo: {
                  ...formData.contactInfo,
                  phone: e.target.value,
                },
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
            placeholder="Enter phone number"
          />
        </div>

        {/* EMAIL */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            value={formData?.contactInfo?.email}
            onChange={(e) =>
              updateFormData({
                contactInfo: {
                  ...formData.contactInfo,
                  email: e.target.value,
                },
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
            placeholder="Enter email"
          />
        </div>

        {/* WEBSITE */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Website
          </label>
          <input
            type="text"
            value={formData?.contactInfo?.website}
            onChange={(e) =>
              updateFormData({
                contactInfo: {
                  ...formData.contactInfo,
                  website: e.target.value,
                },
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
            placeholder="https://example.com"
          />
        </div>

      </div>
    </div>
  </div>
  )
};

export default BasicInfo;
